import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import ListMutations from './list-mutations'
import PageResult from '@/store/entities/page-result';
import appconst from '@/lib/appconst';

// ���Ͷ���
interface StockOrderBatch {
    id: number;
    batchNumber: string;
    creationTime: Date;
    creatorUserName: string;
    isPacked: boolean;
    packedTime?: Date;
    packedUserName?: string;
    count: number;
}

interface StockOrderBatchState extends ListState<StockOrderBatch> {
    batchModel: any;
    batchDetailModel: any;
    id: number;
}

class StockOrderBatchMutations extends ListMutations<StockOrderBatch> {
}

class BackStockOrderBatch extends ListModule<StockOrderBatchState, any, any> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<StockOrderBatch>(),
        loading: false,
        batchModel: {} as any,
        batchDetailModel: {} as any,
        id: 0
    }

    actions = {
        // 1. ��ȡ�����б� - �޸����������ݹ����ʹ��
        async getStockOrderBatchList(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            context.state.loading = true;
            try {
                const response = await Ajax.get('/api/services/app/StockOrderBatch/GetStockOrderBatchList', {
                    params: payload.data
                });

                const page = response.data.result as PageResult<StockOrderBatch>;

                // ���� state
                context.commit('setList', page.items);
                context.commit('setTotalCount', page.totalCount);

                // ͬʱ�������ݹ����ʹ�ã������Ҫ��
                return {
                    items: page.items,
                    totalCount: page.totalCount
                };

            } catch (error) {
                console.error('��ȡ�����б�ʧ��:', error);
                throw error;
            } finally {
                context.state.loading = false;
            }
        },
        // 2. ��������
        async createBatch(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            const response = await Ajax.post(`/api/services/app/StockOrderBatch/CreateBatch`, payload.data);
            return response.data.result;
        },

        // 3. ȡ������
        async cancelBatch(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/StockOrderBatch/CancelBatch?batchId=` + payload.data.id);
        },

        // 4. ��������Ϊ�Ѵ��
        async setBatchPacked(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/StockOrderBatch/SetBatchPacked?batchId=` + payload.data.id);
        },
        
        async setBatchArriveWarehouse(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            await Ajax.post(`/api/services/app/StockOrderBatch/SetBatchArriveWarehouse?batchId=` + payload.data.id);
        },
        // 5. ��ȡ��������
        async getBatchDetail(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            const response = await Ajax.get(`/api/services/app/StockOrderBatch/GetBatchDetail?batchId=`+ payload.data.id);
            context.commit('setBatchDetailModel', response.data.result);
            return response.data.result; // ͬʱ��������
        },
        async getBatchStockOrderList(context: ActionContext<StockOrderBatchState, any>, payload: any) {
           /* const response = await Ajax.get(`/api/services/app/StockOrderBatch/GetBatchStockOrderList?batchId=` + payload.data.id);*/
            const response = await Ajax.get(`/api/services/app/StockOrderBatch/GetBatchStockOrderList?batchName=` + payload.data.batchName + "&isBox=" + payload.data.isBox);
            return response.data.result; // ͬʱ��������
        },

        async getStockOrderBatchListForH5(context: ActionContext<StockOrderBatchState, any>, payload: any) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/StockOrderBatch/GetStockOrderBatchList', {
                params: {
                    ...payload.data,
                    skipCount: 0,
                    maxResultCount: 20
                }
            });
            const page = response.data.result as PageResult<any>;
            context.commit('setList', page.items);
            context.commit('setTotalCount', page.totalCount);
            context.state.loading = false;
            return {
                items: page.items,
                totalCount: page.totalCount
            };
        },

        async createPick(
            context: ActionContext<StockOrderBatchState, any>,
            payload: { batchId: number; userId?: number | null, isBox?: boolean }  // ���� userId ����
        ) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/CreatePick', null, {
                params: {
                    batchId: payload.batchId,
                    userId: payload.userId,
                    isBox: payload.isBox,
                }
            });
            return response.data;
        },

        // �������������÷����û�
        async setAllocateUserId(
            context: ActionContext<StockOrderBatchState, any>,
            payload: { batchId: number; userId: number }
        ) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/SetAllocateUserId', null, {
                params: {
                    batchId: payload.batchId,
                    userId: payload.userId
                }
            });
            return response.data;
        },

        // ��ȡ��ѡ����
        async getPickDetail(context: ActionContext<StockOrderBatchState, any>, payload: { batchId: number }) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/StockOrderBatch/GetPickDetai', {
                params: {
                    batchId: payload.batchId
                }
            });
            const pickDetailList = response.data.result;
            return pickDetailList;
        },

        // ��ȡ��ѡ����
        async getPickDetaiList(context: ActionContext<StockOrderBatchState, any>, payload: { batchId: number, code: string }) {
            context.state.loading = true;
            const response = await Ajax.get('/api/services/app/StockOrderBatch/GetPickDetaiList', {
                params: {
                    batchId: payload.batchId,
                    code: payload.code
                }
            });
            const pickDetailList = response.data.result;
            return pickDetailList;
        },

        // ���Ӽ�ѡ����
        async addPickCount(context: ActionContext<StockOrderBatchState, any>, payload: { id: number; count: number }) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/AddPickCount', null, {
                params: {
                    id: payload.id,
                    count: payload.count
                }
            });
            return response.data;
        },

        // ���ü�ѡ����
        async setPick(context: ActionContext<StockOrderBatchState, any>, payload: { id: number; count: number }) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/SetPick', null, {
                params: {
                    id: payload.id,
                    count: payload.count
                }
            });
            return response.data;
        },

        // ���ü�ѡ����
        async deleteOrder(context: ActionContext<StockOrderBatchState, any>, payload: { orderId: number;}) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/DeleteOrder', null, {
                params: {
                    orderId: payload.orderId,
                }
            });
            return response.data;
        },

        // ���ü�ѡ����
        async resetBatch(context: ActionContext<StockOrderBatchState, any>, payload: { batchId: number; }) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/ResetBatch', null, {
                params: {
                    batchId: payload.batchId,
                }
            });
            return response.data;
        },

        // ������ɼ�ѡ
        async setCompletePick(context: ActionContext<StockOrderBatchState, any>, payload: { batchId: number }) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/SetCompletePick', null, {
                params: {
                    batchId: payload.batchId
                }
            });
            return response.data;
        },

        // �������������÷����û�
        async addScan(
            context: ActionContext<StockOrderBatchState, any>,
            payload: { batchId: number; productNo: string, isEnable: boolean }
        ) {
            const response = await Ajax.post('/api/services/app/StockOrderBatch/AddScan', payload);
            return response.data;
        },
    };

    mutations = {
        setCurrentPage(state: StockOrderBatchState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: StockOrderBatchState, pagesize: number) {
            state.pageSize = pagesize;
        },
        setBatchModel(state: StockOrderBatchState, model: any) {
            state.batchModel = model;
        },
        setBatchDetailModel(state: StockOrderBatchState, model: any) {
            state.batchDetailModel = model;
        },
        // �����б���� mutations
        setList(state: StockOrderBatchState, list: StockOrderBatch[]) {
            state.list = list;
        },
        setTotalCount(state: StockOrderBatchState, totalCount: number) {
            state.totalCount = totalCount;
        },
        getPrint(state: StockOrderBatchState, data: any) {
            data.url = appconst.remoteServiceBaseUrl + "api/File/GetOrderBatch?barCode=" + data.barCode + "&shelfPosition=" + data.shelfPosition + "&imageUrl=" + data.imageUrl + (data.isRotate != null ? "&isRotate=" + data.isRotate : "") + (data.isBox != null ? "&isBox=" + data.isBox : "");
        },
        getDetailPrint(state: StockOrderBatchState, data: any) {
            data.url = appconst.remoteServiceBaseUrl + "api/File/GetBatchDetail?barCode=" + data.barCode + "&currentPage=" + data.currentPage;
        },
    }
}

const backStockOrderBatch = new BackStockOrderBatch();
export default backStockOrderBatch;